<div id="app" class="h-100 app">
    <router-outlet></router-outlet>

    <!-- Global Engraving Modal Host -->
    @if (isEngravingModalOpen$ | async) {
        <app-apple-engraving
            [data]="engravingModalData$ | async"
            (close)="onEngravingClose()"
            (save)="onEngravingSave($event)"
            (skip)="onEngravingSkip()"
        ></app-apple-engraving>
    }
    @if (isAppleCareModalOpen$ | async) {
        <app-applecare-modal></app-applecare-modal>
    }
</div>
